<template>
  <b-modal
    id="school-employee-leave-modal"
    size="lg"
    ok-only
    title="Individual Leave"
  >
    <EmployeeIndividualLeaveTable :leaves="leaves" :is-busy="isBusy">
    </EmployeeIndividualLeaveTable>

    <div class="d-flex justify-content-end" v-if="leaves.length">
      <b-pagination
        pills
        size="lg"
        class="pt-5"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        @change="$emit('page-change', $event)"
      ></b-pagination>
    </div>
  </b-modal>
</template>

<script>
import EmployeeIndividualLeaveTable from "@/modules/company/components/attendance/common/table/EmployeeIndividualLeaveTable";

export default {
  name: "EmployeeIndividualLeaveModal",
  components: { EmployeeIndividualLeaveTable },
  props: {
    leaves: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    pagination: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
